import { Link } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout.jsx';
import { BillingSetup } from '../../components/BillingSetup.jsx';

/**
 * Brand billing.
 *
 * Spells out the money flow, because "we charge you when you pay a creator" is
 * a claim worth being precise about — brands have been burned by networks that
 * take a deposit and sit on it.
 */
export default function BrandBilling() {
  return (
    <DashboardLayout
      side="brand"
      title="Billing"
      description="How commissions get funded."
    >
      <div className="max-w-2xl space-y-8">
        <BillingSetup />

        <section className="rounded-lg border border-rule bg-paper-raised p-5">
          <h2 className="text-sm font-semibold">How the money moves</h2>
          <ol className="mt-3 space-y-3 text-sm text-ink-muted">
            {[
              ['A conversion is tracked', 'A commission accrues against your program at the terms the creator accepted.'],
              ['You settle it', 'Your confirmation that the order is real and not refunded. No money moves yet.'],
              ['You pay a creator', 'We charge your card the commission plus your share of Affily’s fee and the card fee, and only once that clears do we transfer the creator their share. Large amounts can be paid by bank transfer instead, with no card fee.'],
            ].map(([title, body], i) => (
              <li key={title} className="flex gap-3">
                <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-ink text-xs font-semibold text-paper">
                  {i + 1}
                </span>
                <span>
                  <span className="block font-medium text-ink">{title}</span>
                  {body}
                </span>
              </li>
            ))}
          </ol>

          <p className="mt-4 border-t border-rule pt-3 text-xs text-ink-faint">
            No deposit and nothing held on a card. We charge at the moment you pay a creator and not a
            moment earlier, and you are never billed for a commission you haven’t settled. What you
            send by bank transfer stays yours until you pay a creator from it. Your rates are on the{' '}
            <Link to="/dashboard/pricing" className="text-accent hover:underline">pricing page</Link>.
          </p>
        </section>
      </div>
    </DashboardLayout>
  );
}
